import React from 'react';
import { motion } from 'framer-motion';
import { AiOutlineArrowRight } from 'react-icons/ai';
import './Blog.css';

// Using existing assets for placeholder mockups
import img1 from '../../assets/images/about_img01.jpg';
import img2 from '../../assets/images/trust01.jpg';
import img3 from '../../assets/images/about_img02.jpg';

const BLOG_DATA = [
  { id: 1, title: 'Choosing the right roofing material for your home', date: 'October 24, 2023', img: img1 },
  { id: 2, title: 'How to extend the life of your roof', date: 'December 12, 2023', img: img2 },
  { id: 3, title: '5 Warning signs your roof needs repair', date: 'October 24, 2023', img: img3 },
];

function Blog() {
  return (
    <section className="blog" id="Blog">
      <div className="container">
        
        <div className="blog__header">
          <motion.h2
            className="blog__title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Our blog
          </motion.h2>
        </div>

        <div className="blog__grid">
          {BLOG_DATA.map((post, idx) => (
            <motion.div 
              key={post.id}
              className="blog__card"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.15 }}
            >
              <img src={post.img} alt={post.title} className="blog__card-img" />
              <h3 className="blog__card-title">{post.title}</h3>
              <span className="blog__card-date">{post.date}</span>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="pre-footer-cta"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div>
            <h3>Get a free estimate today</h3>
            <p>Ready to upgrade your property? Our experts are standing by to provide a comprehensive, transparent quote with zero obligations.</p>
          </div>
          <a href="#Contact" className="btn btn-primary">
            <span>Request a free estimate</span>
            <AiOutlineArrowRight aria-hidden="true" />
          </a>
        </motion.div>

      </div>
    </section>
  );
}

export default Blog;
